import { toProperCase } from './common'

// Fixed default per product decision: Practice + TIN are the only types common
// enough across tenants to hardcode. Diverge also uses Market, but Vytalize
// doesn't (region/pod instead), so no third default — tenants that lack
// Practice or TIN just show whichever of the two they have.
const PINNED_TYPE_NAMES = ['practice', 'tin']

// toProperCase title-cases every word, which turns the acronym "TIN" into
// "Tin". Keep a small exception list for type names that should stay
// all-caps instead of going through the generic title-case formatter.
const ACRONYM_TYPE_NAMES = new Set(['tin'])

export function getPinnedTypes(types) {
  const found = []
  for (const name of PINNED_TYPE_NAMES) {
    const match = types.find((t) => t.type_name.toLowerCase() === name)
    if (match) found.push(match)
  }
  if (found.length > 0) return found
  // Neither Practice nor TIN exists for this tenant (e.g. region/pod naming) —
  // fall back to the first couple of types so the row isn't empty by default.
  return types.slice(0, 2)
}

export function formatEntityTypeName(name) {
  if (!name) return ''
  if (ACRONYM_TYPE_NAMES.has(name.toLowerCase())) return name.toUpperCase()
  return toProperCase(name)
}
